<template>
  <div v-if="show">
    <div class="modal olympic-modal letter fade show" style="display: block;" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="title-with-icon">
              <div class="title-with-icon__icon title-with-icon__icon_login"></div>
              <div class="title-with-icon__title">
                <span class="title-letter">Третий этап олимпиады</span>
              </div>
            </div>
            <button type="button" class="close modal-close" @click="$emit('close')" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="olympics-step3-content">
              <div class="step3-image">
                <img src="/pic/owl.png" alt="Третий этап олимпиады" />
              </div>
              <div class="step3-text">
                <h3>Добро пожаловать на третий этап Олимпиады</h3>
                <p class="step3-description">
                  Перед вами — ответственность за логистику, таможенное оформление, выбор условий поставки и контроль затрат. Ошибка в документах, неверный расчёт или выбор неэффективного маршрута могут привести к задержкам, штрафам и убыткам.
                </p>
                <p class="step3-description">
                  Ваша задача — координировать все процессы, минимизировать риски и обеспечить своевременную доставку первой партии подсолнечного масла в Турцию.
                </p>
                <p class="step3-description">
                  Удачи! От вас зависит, пройдёт ли груз без задержек и принесёт ли сделка прибыль.
                </p>
                <div class="step3-button-container">
                  <button @click="handleBegin" class="btn btn-primary">
                    Начать третий этап
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop show"></div>
  </div>
</template>

<script>
export default {
  name: 'OlympicsStep3Modal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close', 'begin'],
  methods: {
    handleBegin() {
      this.$emit('begin')
    }
  }
}
</script>

<style scoped>
.olympics-step3-content {
  text-align: center;
  padding: 2rem 0;
}

.step3-image {
  margin-bottom: 2rem;
}

.step3-image img {
  max-width: 200px;
  height: auto;
  border-radius: 8px;
}

.step3-text h3 {
  color: #002E5E;
  font-size: 2.4rem;
  font-weight: 700;
  margin-bottom: 2rem;
  line-height: 1.3;
}

.step3-description {
  font-size: 1.6rem;
  line-height: 2.4rem;
  color: #333;
  margin-bottom: 1.5rem;
  text-align: left;
}

.step3-button-container {
  margin-top: 3rem;
}

@media (max-width: 768px) {
  .step3-image img {
    max-width: 150px;
  }
  
  .step3-text h3 {
    font-size: 2rem;
  }
  
  .step3-description {
    font-size: 1.4rem;
    line-height: 2rem;
  }
}
</style>
